// extracted by mini-css-extract-plugin
export var contentContainer = "_404-module--contentContainer--e0568";
export var header = "_404-module--header--55f20";
export var headline = "_404-module--headline--bba8c";
export var logo = "_404-module--logo--f3d20";
export var pageStyles = "_404-module--pageStyles--b56ac";
export var text = "_404-module--text--52252";
export var white = "_404-module--white--87d3f";